import { render, staticRenderFns } from "./canvass.vue?vue&type=template&id=342fa22f&scoped=true&"
import script from "./canvass.vue?vue&type=script&lang=js&"
export * from "./canvass.vue?vue&type=script&lang=js&"
import style0 from "./canvass.vue?vue&type=style&index=0&id=342fa22f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342fa22f",
  null
  
)

export default component.exports